(() => {
  const dateToISO = (date) => {
    return date.toISOString().split("T")[0];
  };

  document.querySelectorAll("button[data-date-value]").forEach((button, _i) => {
    const dateValue = button.getAttribute("data-date-value");
    const targetName = button.getAttribute("data-date-target");
    const dateInput = document.querySelector(
      `input[type="date"][name="${targetName}"]`,
    );
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    let date;

    const changeEvent = new Event("change");

    if (dateValue === "today") {
      date = today;
    } else if (dateValue === "tomorrow") {
      date = tomorrow;
    }

    button.addEventListener("click", (event) => {
      event.preventDefault();
      dateInput.value = dateToISO(date);
      dateInput.dispatchEvent(changeEvent); // to trigger validations
    });
  });
})();
